<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="1000"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">

            <Row>
                <Col span="24">
                    <Card :bordered="false" dis-hover>
                        <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 基本信息</template>
                        <DescriptionList class="show-description-title" title=""  layout="vertical">
                            <Description term="供应商名称：">
                                {{detail.company}}
                            </Description>
                            <Description term="供应商类型：">
                                <Tag>{{detail.type_name}}</Tag>
                            </Description>
                            <Description term="供应商等级：">
                                <Tag>{{detail.level_name}}</Tag>
                            </Description>
                            <Description term="联系人：">
                               {{detail.name}}
                            </Description>
                            <Description term="手机号码：">
                                {{detail.mobile}}
                            </Description>
                            <Description term="固定电话：">
                                {{detail.mobile}}
                            </Description>
                            <Description term="电子邮箱：">
                                {{detail.email}}
                            </Description>
                            <Description term="微信账号：">
                                {{detail.wechat}}
                            </Description>
                            <Description term="公司地址：" >
                                <Ellipsis :text="detail.address" :height="20" tooltip />
                            </Description>
                            <Description term="主营产品：">
                                <Tag  v-for="(item,index) in detail.business_list" :key="index">{{item.name}}</Tag>
                            </Description>
                            <Description term="销售员：" >
                                {{detail.saler_name}}
                            </Description>
                            <Description term="客户状态：">
                                <Badge v-if="detail.status === 1" status="processing" text="审核" />
                                <Badge v-else-if="detail.status === 2" status="error" text="禁用" />
                                <Badge v-else-if="detail.status === 3" status="success" text="开启" />
                                <Badge v-else status="warning" text="其他" />
                            </Description>
                            <Description term="创建时间：">
                                {{detail.create_time}}
                            </Description>
                            <Description term="更新时间：">
                                {{detail.update_time}}
                            </Description>
                            <Description term="备注信息：">
                                {{detail.remark}}
                            </Description>
                        </DescriptionList>
                    </Card>
                    <Card :bordered="false" dis-hover v-if="!!detail.image && detail.image.length > 0">
                        <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 合同与资质</template>
                        <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical">
                            <Description term="">
                                <div class="uploads">
                                    <div class="upload-images" v-for="(item,index) in detail.image" :key="index" @click.stop="">
                                        <img :src="site_url + item">
                                        <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                                    </div>
                                </div>
                            </Description>
                        </DescriptionList>
                    </Card>
                    <Card :bordered="false" dis-hover>
                        <template #title><Icon type="md-radio-button-on" class="text-primary" size="16" /> 收款账户信息</template>
                        <DescriptionList class="show-description-title" title=""   layout="vertical">
                            <Description term="收款账户：">
                                {{!!detail.bank_account ? detail.bank_account : '-'}}
                            </Description>
                            <Description term="账户实名：">
                                {{!!detail.bank_real_name ? detail.bank_real_name : '-'}}
                            </Description>
                            <Description term="开户银行：">
                                {{!!detail.bank_name ? detail.bank_name : '-'}}
                            </Description>
                            <Description term="开户地址：">
                                {{!!detail.bank_address ? detail.bank_address : '-'}}
                            </Description>
                        </DescriptionList>
                    </Card>
                </Col>
            </Row>
            <div class="box-drawer-footer">
                <Button class="mr10" @click="FormReset()">关闭</Button>
            </div>
        </div>

        <!-- 预览图片 -->
        <Modal
            v-model="is_view_box"
            title="预览"
            :width="840"
            :mask-closable="true"
            :footer-hide="true"
            @on-cancel="PhotoViewClose()">
            <div class="flex-image-box">
                <img :src="view_url" class="flex-image-box-show">
            </div>
        </Modal>
    </Drawer>
</template>

<script>

import {getCompanyDetail} from "@/apis/company";

export default {
    name: 'CompanyShow',
    components: {
    },
    data () {
        return {
            title: '供应商详情',
            detail: [],
            isBox: false,
            site_url: this.$siteApi,
            is_view_box: false,
            view_url: ''
        }
    },
    methods: {
        /**
         功能：图片预览
         time: 2025-17-15 10:17:00
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },
        /**
         功能：
         time: 2025/12/16 10:44
         **/
        GetDetail(id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getCompanyDetail(id).then(e => {
                that.detail = e.data;
                that.title = e.data.company + " - 供应商详情";
            })
        },
        /**
         功能：
         time: 2025/12/16 10:44
         **/
        show(company_id){
            this.isBox = true;
            if(company_id) this.GetDetail(company_id);
        },
        /**
         功能：
         time: 2025/12/16 10:44
         **/
        FormReset(){
            this.isBox = false;
            this.title = '供应商详情';
            this.detail =  [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

</style>
